const HtmlToReactParser = require('html-to-react').Parser;
export const htmlToReactParser = new HtmlToReactParser();

/* use example: <li>{htmlToReactParser.parse(item.question)}</li>
 */
